import Vue from "vue";
import Vuex from "vuex";

import vuei18n from '@/i18n'

Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    user: {
      loggedIn: null, // null means we don't know yet if is loggedIn
      data: null,
      company: null,
      algoliaSecuredKey: null
    }
  },
  getters: {
    user(state){
      return state.user
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user.data = data;
      vuei18n.locale = data ? data.locale : null
    },
    SET_COMPANY(state, data) {
      state.user.company = data;
    },
    SET_ALGOLIA_SECURED_KEY(state, data) {
      state.user.algoliaSecuredKey = data;
    }
  },
  actions: {
    setIsUserLoggedIn({ commit }, loggedIn) {
      commit("SET_LOGGED_IN", loggedIn);
    },
    setUserData({ commit }, userData) {
      commit("SET_USER", userData);
    },
    setCompanyData({ commit }, companyData) {
      commit("SET_COMPANY", companyData);
    },
    setAlgoliaSecuredKey({ commit }, algoliaSecuredKey) {
      commit("SET_ALGOLIA_SECURED_KEY", algoliaSecuredKey);
    },
  }
});
